module.exports = __webpack_public_path__ + "img/service-vpc.ffa45a7.svg";